import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { PatientProfilePatient } from "../../../patientProfileModal.types";

type AgencyVisitSettingsResponse = {
  calendarStartDayOfTheWeek?: number | string | null;
};

export function usePatientProfileWeeklyTemplate(
  patientId: PatientProfilePatient["id"],
  enabled = true
) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["patientProfileModal", patientId, "weeklyTemplate"],
    queryFn: () =>
      api.get("./patients/:patientId/weekly_template_shifts", {
        path: { patientId },
      }),
    enabled,
  });
}

export function useAgencyCalendarFirstDayOfWeek() {
  const { api } = useApi();

  return useQuery({
    queryKey: ["patientProfileModal", "agencyCalendarFirstDayOfWeek"],
    queryFn: () =>
      api.get("/agencies/:agencyId/settings", {}) as Promise<AgencyVisitSettingsResponse>,
  });
}
